import styled, { css } from 'styled-components';
import Flex from '../Flex/Flex';
import theme from '../../assets/styles/theme';

const TabGroup = styled(Flex)`
  height: 40px;
  color: ${theme.colors.neutral.text.strong};
`;

const TabGroupTab = styled(Flex)`
  cursor: pointer;
  text-align: center;
  text-transform: none;
  color: ${theme.colors.neutral.text.regular};
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  outline: none;
  position: relative;
  align-items: center;
  box-shadow: 0 1px 0 0 ${theme.colors.neutral.border.weak};
  &:hover {
    color: ${theme.colors.neutral.text.strong};
    box-shadow: 0 1px 0 0 ${theme.colors.neutral.border.strong};
    background: ${theme.colors.neutral.bg.regular};
  }
  ${({ active }) =>
    active &&
    `color: ${theme.colors['secondary-1'].text.strong};
     box-shadow: 0 1px 0 0  ${theme.colors['secondary-1'].border.regular};
     background: ${theme.colors.neutral.bg.weak};
    `}
`;

const TabGroupTabTitle = styled.div`
  ${theme.textStyles['text-preset-9']()}
  display: flex;
  align-items: center;
  padding-left: ${theme.spacing['spacing-5']};
  padding-right: ${theme.spacing['spacing-5']};
  padding-top: ${theme.spacing['spacing-3']};
  padding-bottom: ${theme.spacing['spacing-3']};
  > * {
    margin-left: ${theme.spacing['spacing-2']};
  }
`;

export { TabGroup, TabGroupTab, TabGroupTabTitle };
